export const BRAND = 'DutiLyne';
export const DESCRIPTOR = 'Pharmacy POS';
export const TAGLINE = 'Closer to your patients, Connected to your Pharmacy.';

// The DutiLyne brand set, self-hosted under /brand/ so it still works
// offline in the desktop app.

// Icon mark only (cross/"D" on a mint-ringed rounded-square badge). It
// carries its own solid background, so this single file is used for every
// small/tight-space badge — favicon, app icon, PWA icon, splash, nav bars —
// regardless of the surface it sits on.
export const LOGO_MARK = '/brand/dutilyne-mark.png';

// Full lockup (icon + "DutiLyne" wordmark + tagline) for hero placements,
// matched to the surface behind it.
export const LOGO_LOCKUP_LIGHT = '/brand/dutilyne-lockup-light.png'; // dark text, for light surfaces
export const LOGO_LOCKUP_DARK = '/brand/dutilyne-lockup-dark.png'; // light text, for dark surfaces

// Duti AI's face — the DutiLyne pharmacist assistant badge, already a circle
// with transparent corners, so it can sit flush in round avatars and buttons.
export const DUTI_AI_AVATAR = '/brand/duti-ai-192.png';
